import { c as _c } from "react/compiler-runtime";
import { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import parseFabricMaterial from 'commons/parseFabricMaterial';
import { fabricObject } from '../utils';
const DEFAULT_FABRIC_LIST = [];
const useFabricsPageState = (t0, parseQueryParams, syncStateToUrl, updateQueryParams) => {
  const $ = _c(127);
  const fabricList = t0 === undefined ? DEFAULT_FABRIC_LIST : t0;
  const [selectedFabric, setSelectedFabric] = useState(null);
  const [selectedMaterialType, setSelectedMaterialType] = useState("Fabric");
  const [sortBy, setSortBy] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedColors, setSelectedColors] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [selectedFeatures, setSelectedFeatures] = useState(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [selectedTiers, setSelectedTiers] = useState(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [selectedGrades, setSelectedGrades] = useState(t4);
  const isInitializedFromParamsRef = useRef(false);
  const skipNextSyncRef = useRef(false);
  let t5;
  if ($[4] !== fabricList) {
    t5 = fabricList.filter(_temp);
    $[4] = fabricList;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const fabricsData = t5;
  let t6;
  if ($[6] !== fabricList) {
    t6 = fabricList.filter(_temp2);
    $[6] = fabricList;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const leathersData = t6;
  let t7;
  let t8;
  if ($[8] !== parseQueryParams) {
    t7 = () => {
      if (isInitializedFromParamsRef.current) {
        return;
      }
      isInitializedFromParamsRef.current = true;
      const params = parseQueryParams();
      if (Object.keys(params).length > 0) {
        if (params.material) {
          setSelectedMaterialType(params.material);
        }
        if (params.sort) {
          setSortBy(params.sort);
        }
        if (params.color && Object.keys(params.color).length > 0) {
          setSelectedColors(params.color);
        }
        if (params.feature && Object.keys(params.feature).length > 0) {
          setSelectedFeatures(params.feature);
        }
        if (params.tier && params.tier.length > 0) {
          setSelectedTiers(params.tier);
        }
        if (params.grade && params.grade.length > 0) {
          setSelectedGrades(params.grade);
        }
      }
    };
    t8 = [parseQueryParams];
    $[8] = parseQueryParams;
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  useEffect(t7, t8);
  let t9;
  bb0: {
    const materialTypeFiltered = selectedMaterialType === "Fabric" ? fabricsData : leathersData;
    if (selectedMaterialType !== "Fabric") {
      const hasSelectedGrades = selectedGrades.length > 0;
      if (!hasSelectedGrades) {
        t9 = materialTypeFiltered;
        break bb0;
      }
      let t10;
      if ($[11] !== materialTypeFiltered || $[12] !== selectedGrades) {
        let t11;
        if ($[14] !== selectedGrades) {
          t11 = leather => selectedGrades.includes(leather.option_value_grade);
          $[14] = selectedGrades;
          $[15] = t11;
        } else {
          t11 = $[15];
        }
        t10 = materialTypeFiltered.filter(t11);
        $[11] = materialTypeFiltered;
        $[12] = selectedGrades;
        $[13] = t10;
      } else {
        t10 = $[13];
      }
      t9 = t10;
      break bb0;
    }
    let t10;
    if ($[16] !== selectedColors) {
      t10 = Object.keys(selectedColors);
      $[16] = selectedColors;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    const hasSelectedColors = t10.length > 0;
    let t11;
    if ($[18] !== selectedFeatures) {
      t11 = Object.keys(selectedFeatures);
      $[18] = selectedFeatures;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    const hasSelectedFeatures = t11.length > 0;
    const hasSelectedTiers = selectedTiers.length > 0;
    if (!hasSelectedColors && !hasSelectedFeatures && !hasSelectedTiers) {
      t9 = materialTypeFiltered;
      break bb0;
    }
    let t12;
    if ($[20] !== hasSelectedColors || $[21] !== hasSelectedFeatures || $[22] !== hasSelectedTiers || $[23] !== materialTypeFiltered || $[24] !== selectedColors || $[25] !== selectedFeatures || $[26] !== selectedTiers) {
      let t13;
      if ($[28] !== hasSelectedColors || $[29] !== hasSelectedFeatures || $[30] !== hasSelectedTiers || $[31] !== selectedColors || $[32] !== selectedFeatures || $[33] !== selectedTiers) {
        t13 = fabric => {
          const materials = parseFabricMaterial(fabric.group_material);
          const hasValidColor = !hasSelectedColors || selectedColors[fabric?.option_color];
          const hasValidFeature = !hasSelectedFeatures || (!selectedFeatures.pet_friendly || fabric.pet_friendly === 1) && (!selectedFeatures.velvet || materials.includes("velvet")) && (!selectedFeatures.sustainable_fabric || fabric.sustainable_fabric === 1) && (!selectedFeatures.safeguard || fabric.performance_fabric === 1) && (!selectedFeatures.greenguard_gold || materials.includes("greenguard") || materials.includes("greenguard-gold")) && (!selectedFeatures.pantone || fabric.pantone_flag === 1);
          const hasValidTiers = !hasSelectedTiers || selectedTiers.includes(fabric.option_value_tier);
          return hasValidColor && hasValidFeature && hasValidTiers;
        };
        $[28] = hasSelectedColors;
        $[29] = hasSelectedFeatures;
        $[30] = hasSelectedTiers;
        $[31] = selectedColors;
        $[32] = selectedFeatures;
        $[33] = selectedTiers;
        $[34] = t13;
      } else {
        t13 = $[34];
      }
      t12 = materialTypeFiltered.filter(t13);
      $[20] = hasSelectedColors;
      $[21] = hasSelectedFeatures;
      $[22] = hasSelectedTiers;
      $[23] = materialTypeFiltered;
      $[24] = selectedColors;
      $[25] = selectedFeatures;
      $[26] = selectedTiers;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    t9 = t12;
  }
  const filteredFabricList = t9;
  let t10;
  bb1: {
    if (!filteredFabricList.length) {
      let t11;
      if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = [];
        $[35] = t11;
      } else {
        t11 = $[35];
      }
      t10 = t11;
      break bb1;
    }
    let t11;
    if ($[36] !== filteredFabricList) {
      t11 = filteredFabricList.map(_temp3);
      $[36] = filteredFabricList;
      $[37] = t11;
    } else {
      t11 = $[37];
    }
    t10 = t11;
  }
  const fabricObjects = t10;
  let t11;
  bb2: {
    if (!fabricObjects.length > 0) {
      t11 = null;
      break bb2;
    }
    let t12;
    if ($[38] !== parseQueryParams) {
      t12 = parseQueryParams();
      $[38] = parseQueryParams;
      $[39] = t12;
    } else {
      t12 = $[39];
    }
    const params_0 = t12;
    if (params_0.fabric) {
      let t13;
      if ($[40] !== fabricObjects || $[41] !== params_0.fabric) {
        let t14;
        if ($[43] !== params_0.fabric) {
          t14 = fabric_1 => fabric_1?.footerTitle?.name.trim() === params_0.fabric;
          $[43] = params_0.fabric;
          $[44] = t14;
        } else {
          t14 = $[44];
        }
        t13 = fabricObjects.find(t14);
        $[40] = fabricObjects;
        $[41] = params_0.fabric;
        $[42] = t13;
      } else {
        t13 = $[42];
      }
      const matchedFabric = t13;
      t11 = matchedFabric || null;
      break bb2;
    }
    t11 = null;
  }
  const initialSelectedFabric = t11;
  let t12;
  let t13;
  if ($[45] !== initialSelectedFabric) {
    t12 = () => {
      if (initialSelectedFabric) {
        setSelectedFabric(prev => {
          if (!prev || prev?.footerTitle?.name !== initialSelectedFabric?.footerTitle?.name) {
            skipNextSyncRef.current = true;
            return initialSelectedFabric;
          }
          return prev;
        });
      }
    };
    t13 = [initialSelectedFabric];
    $[45] = initialSelectedFabric;
    $[46] = t12;
    $[47] = t13;
  } else {
    t12 = $[46];
    t13 = $[47];
  }
  useEffect(t12, t13);
  let t14;
  if ($[48] !== selectedFabric?.footerTitle?.name) {
    t14 = () => selectedFabric?.footerTitle?.name || null;
    $[48] = selectedFabric?.footerTitle?.name;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  selectedFabric?.footerTitle?.name;
  let t15;
  if ($[50] !== t14) {
    t15 = t14();
    $[50] = t14;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  const selectedFabricKey = t15;
  let t16;
  if ($[52] !== selectedColors || $[53] !== selectedFabric || $[54] !== selectedFeatures || $[55] !== selectedGrades || $[56] !== selectedMaterialType || $[57] !== selectedTiers || $[58] !== sortBy || $[59] !== syncStateToUrl) {
    t16 = () => {
      if (!isInitializedFromParamsRef.current) {
        return;
      }
      if (skipNextSyncRef.current) {
        skipNextSyncRef.current = false;
        return;
      }
      syncStateToUrl({
        selectedMaterialType,
        sortBy,
        selectedColors,
        selectedFeatures,
        selectedTiers,
        selectedGrades,
        selectedFabric
      });
    };
    $[52] = selectedColors;
    $[53] = selectedFabric;
    $[54] = selectedFeatures;
    $[55] = selectedGrades;
    $[56] = selectedMaterialType;
    $[57] = selectedTiers;
    $[58] = sortBy;
    $[59] = syncStateToUrl;
    $[60] = t16;
  } else {
    t16 = $[60];
  }
  let t17;
  if ($[61] !== selectedColors || $[62] !== selectedFabric || $[63] !== selectedFabricKey || $[64] !== selectedFeatures || $[65] !== selectedGrades || $[66] !== selectedMaterialType || $[67] !== selectedTiers || $[68] !== sortBy || $[69] !== syncStateToUrl) {
    t17 = [syncStateToUrl, selectedMaterialType, sortBy, selectedColors, selectedFeatures, selectedTiers, selectedGrades, selectedFabricKey, selectedFabric];
    $[61] = selectedColors;
    $[62] = selectedFabric;
    $[63] = selectedFabricKey;
    $[64] = selectedFeatures;
    $[65] = selectedGrades;
    $[66] = selectedMaterialType;
    $[67] = selectedTiers;
    $[68] = sortBy;
    $[69] = syncStateToUrl;
    $[70] = t17;
  } else {
    t17 = $[70];
  }
  useEffect(t16, t17);
  let t18;
  bb3: {
    if (!fabricObjects.length) {
      let t19;
      if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = {
          byFamily: null,
          byColor: null
        };
        $[71] = t19;
      } else {
        t19 = $[71];
      }
      t18 = t19;
      break bb3;
    }
    let t19;
    if ($[72] !== fabricObjects) {
      t19 = fabricObjects.reduce(_temp4, {
        byFamily: new Map(),
        byColor: new Map()
      });
      $[72] = fabricObjects;
      $[73] = t19;
    } else {
      t19 = $[73];
    }
    t18 = t19;
  }
  const groupedFabrics = t18;
  let t19;
  bb4: {
    if (!fabricObjects.length) {
      let t20;
      if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = [];
        $[74] = t20;
      } else {
        t20 = $[74];
      }
      t19 = t20;
      break bb4;
    }
    if (sortBy === "Family Name" && groupedFabrics.byFamily) {
      let t20;
      if ($[75] !== groupedFabrics.byFamily) {
        t20 = Array.from(groupedFabrics.byFamily.entries()).map(_temp5).sort(_temp6);
        $[75] = groupedFabrics.byFamily;
        $[76] = t20;
      } else {
        t20 = $[76];
      }
      t19 = t20;
      break bb4;
    }
    if (sortBy === "Colors" && groupedFabrics.byColor) {
      let t20;
      if ($[77] !== groupedFabrics.byColor) {
        t20 = Array.from(groupedFabrics.byColor.values()).flat();
        $[77] = groupedFabrics.byColor;
        $[78] = t20;
      } else {
        t20 = $[78];
      }
      t19 = t20;
      break bb4;
    }
    t19 = fabricObjects;
  }
  const displayFabricList = t19;
  let t20;
  if ($[79] !== fabricsData) {
    const colors = fabricsData.reduce(_temp7, []);
    t20 = new Set(colors);
    $[79] = fabricsData;
    $[80] = t20;
  } else {
    t20 = $[80];
  }
  let t21;
  if ($[81] !== t20) {
    t21 = [...t20];
    $[81] = t20;
    $[82] = t21;
  } else {
    t21 = $[82];
  }
  const fabricColors = t21;
  let t22;
  if ($[83] !== fabricsData) {
    const tiers = fabricsData.reduce(_temp8, []);
    t22 = [...new Set(tiers)].sort(_temp9);
    $[83] = fabricsData;
    $[84] = t22;
  } else {
    t22 = $[84];
  }
  const fabricTiers = t22;
  let t23;
  if ($[85] !== leathersData) {
    const grades = leathersData.reduce(_temp10, []);
    t23 = [...new Set(grades)].sort(_temp11);
    $[85] = leathersData;
    $[86] = t23;
  } else {
    t23 = $[86];
  }
  const leatherGrades = t23;
  let t24;
  bb5: {
    if (selectedMaterialType === "Leather") {
      t24 = selectedGrades.length;
      break bb5;
    }
    let t25;
    if ($[87] !== selectedColors) {
      t25 = Object.keys(selectedColors);
      $[87] = selectedColors;
      $[88] = t25;
    } else {
      t25 = $[88];
    }
    const colorFilters = t25.length;
    const tierFilters = selectedTiers.length;
    let t26;
    if ($[89] !== selectedFeatures) {
      t26 = Object.keys(selectedFeatures);
      $[89] = selectedFeatures;
      $[90] = t26;
    } else {
      t26 = $[90];
    }
    const featureFilters = t26.length;
    t24 = colorFilters + tierFilters + featureFilters;
  }
  const numberOfActiveFilters = t24;
  let t25;
  if ($[91] !== updateQueryParams) {
    t25 = color_0 => {
      setSelectedColors(prevSelectedColors => {
        const updatedColors = {
          ...prevSelectedColors
        };
        if (updatedColors[color_0]) {
          delete updatedColors[color_0];
        } else {
          updatedColors[color_0] = true;
        }
        const colorKeys = Object.keys(updatedColors).filter(key => updatedColors[key]);
        updateQueryParams("color", null, colorKeys);
        return updatedColors;
      });
    };
    $[91] = updateQueryParams;
    $[92] = t25;
  } else {
    t25 = $[92];
  }
  const toggleSelectedColor = t25;
  let t26;
  if ($[93] !== updateQueryParams) {
    t26 = feature => {
      setSelectedFeatures(prevSelectedFeatures => {
        const updatedFeatures = {
          ...prevSelectedFeatures
        };
        if (updatedFeatures[feature]) {
          delete updatedFeatures[feature];
        } else {
          updatedFeatures[feature] = true;
        }
        const featureKeys = Object.keys(updatedFeatures).filter(key_0 => updatedFeatures[key_0]);
        updateQueryParams("feature", null, featureKeys);
        return updatedFeatures;
      });
    };
    $[93] = updateQueryParams;
    $[94] = t26;
  } else {
    t26 = $[94];
  }
  const toggleSelectedFeature = t26;
  let t27;
  if ($[95] !== updateQueryParams) {
    t27 = tier => {
      setSelectedTiers(prevSelectedTiers => {
        const newTiers = prevSelectedTiers.includes(tier) ? prevSelectedTiers.filter(t => t !== tier) : [...prevSelectedTiers, tier];
        updateQueryParams("tier", null, newTiers.map(_temp12));
        return newTiers;
      });
    };
    $[95] = updateQueryParams;
    $[96] = t27;
  } else {
    t27 = $[96];
  }
  const toggleSelectedTier = t27;
  let t28;
  if ($[97] !== updateQueryParams) {
    t28 = grade => {
      setSelectedGrades(prevSelectedGrades => {
        const newGrades = prevSelectedGrades.includes(grade) ? prevSelectedGrades.filter(g => g !== grade) : [...prevSelectedGrades, grade];
        updateQueryParams("grade", null, newGrades.map(_temp13));
        return newGrades;
      });
    };
    $[97] = updateQueryParams;
    $[98] = t28;
  } else {
    t28 = $[98];
  }
  const toggleSelectedGrade = t28;
  let t29;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = fabric_5 => {
      setSelectedFabric(fabric_5);
    };
    $[99] = t29;
  } else {
    t29 = $[99];
  }
  const onFabricSelection = t29;
  let t30;
  if ($[100] !== updateQueryParams) {
    t30 = value => {
      setSortBy(value);
      updateQueryParams("sort", value);
    };
    $[100] = updateQueryParams;
    $[101] = t30;
  } else {
    t30 = $[101];
  }
  const handleSetSortBy = t30;
  let t31;
  if ($[102] !== updateQueryParams) {
    t31 = materialType => {
      setSelectedMaterialType(materialType);
      updateQueryParams("material", materialType);
    };
    $[102] = updateQueryParams;
    $[103] = t31;
  } else {
    t31 = $[103];
  }
  const handleMaterialTypeChange = t31;
  let t32;
  if ($[104] !== updateQueryParams) {
    t32 = () => {
      setSelectedColors({});
      setSelectedFeatures({});
      setSelectedTiers([]);
      setSelectedGrades([]);
      updateQueryParams("color", null, []);
      updateQueryParams("feature", null, []);
      updateQueryParams("tier", null, []);
      updateQueryParams("grade", null, []);
    };
    $[104] = updateQueryParams;
    $[105] = t32;
  } else {
    t32 = $[105];
  }
  const clearAllFilters = t32;
  let t33;
  if ($[106] !== clearAllFilters || $[107] !== displayFabricList || $[108] !== fabricColors || $[109] !== fabricTiers || $[110] !== handleMaterialTypeChange || $[111] !== handleSetSortBy || $[112] !== initialSelectedFabric || $[113] !== leatherGrades || $[114] !== numberOfActiveFilters || $[115] !== selectedColors || $[116] !== selectedFabric || $[117] !== selectedFeatures || $[118] !== selectedGrades || $[119] !== selectedMaterialType || $[120] !== selectedTiers || $[121] !== sortBy || $[122] !== toggleSelectedColor || $[123] !== toggleSelectedFeature || $[124] !== toggleSelectedGrade || $[125] !== toggleSelectedTier) {
    t33 = {
      initialSelectedFabric,
      selectedMaterialType,
      sortBy,
      selectedColors,
      selectedFeatures,
      selectedTiers,
      selectedGrades,
      selectedFabric,
      fabricColors,
      fabricTiers,
      leatherGrades,
      displayFabricList,
      numberOfActiveFilters,
      handleMaterialTypeChange,
      handleSetSortBy,
      toggleSelectedColor,
      toggleSelectedFeature,
      toggleSelectedTier,
      toggleSelectedGrade,
      onFabricSelection,
      clearAllFilters
    };
    $[106] = clearAllFilters;
    $[107] = displayFabricList;
    $[108] = fabricColors;
    $[109] = fabricTiers;
    $[110] = handleMaterialTypeChange;
    $[111] = handleSetSortBy;
    $[112] = initialSelectedFabric;
    $[113] = leatherGrades;
    $[114] = numberOfActiveFilters;
    $[115] = selectedColors;
    $[116] = selectedFabric;
    $[117] = selectedFeatures;
    $[118] = selectedGrades;
    $[119] = selectedMaterialType;
    $[120] = selectedTiers;
    $[121] = sortBy;
    $[122] = toggleSelectedColor;
    $[123] = toggleSelectedFeature;
    $[124] = toggleSelectedGrade;
    $[125] = toggleSelectedTier;
    $[126] = t33;
  } else {
    t33 = $[126];
  }
  return t33;
};
export default useFabricsPageState;
function _temp(item) {
  return item.option_name === "Fabric";
}
function _temp2(item_0) {
  return item_0.option_name === "Leather";
}
function _temp3(fabric_0) {
  return fabricObject(fabric_0);
}
function _temp4(acc, fabric_2) {
  const group = fabric_2.option?.group;
  if (group) {
    if (!acc.byFamily.has(group)) {
      acc.byFamily.set(group, []);
    }
    acc.byFamily.get(group).push(fabric_2);
  }
  const color = fabric_2.option?.color;
  if (color) {
    if (!acc.byColor.has(color)) {
      acc.byColor.set(color, []);
    }
    acc.byColor.get(color).push(fabric_2);
  }
  return acc;
}
function _temp5(t0) {
  const [groupName, groupList] = t0;
  return {
    groupName,
    dataSource: groupList,
    groupDesc: groupList[0]?.subTitle?.name || ""
  };
}
function _temp6(a, b) {
  return a.groupName.localeCompare(b.groupName);
}
function _temp7(acc_0, fabric_3) {
  return fabric_3.option_color ? [...acc_0, fabric_3.option_color] : acc_0;
}
function _temp8(acc_1, fabric_4) {
  return fabric_4.option_value_tier ? [...acc_1, fabric_4.option_value_tier] : acc_1;
}
function _temp9(a_0, b_0) {
  return a_0 - b_0;
}
function _temp10(acc_2, leather_0) {
  return leather_0.option_value_grade ? [...acc_2, leather_0.option_value_grade] : acc_2;
}
function _temp11(a_1, b_1) {
  return a_1 - b_1;
}
function _temp12(t_0) {
  return t_0.toString();
}
function _temp13(g_0) {
  return g_0.toString();
}